import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./CrearPrestamo.css";

export default function CrearPrestamo() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    cliente: "",
    tipo: "Diario",
    monto: "",
    fecha: "",
    plazo: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Datos del préstamo:", form);

    // Aquí luego conectamos al backend
    navigate("/prestamos"); // 🔥 Redirige al listado
  };

  const handleCancel = () => {
    navigate("/prestamos"); // 🔥 También regresa al listado
  };

  return (
    <div className="crear-prestamo-container">

      <h1 className="titulo-principal">Nuevo Préstamo</h1>

      <form className="prestamo-form" onSubmit={handleSubmit}>

        <div className="form-group">
          <label>Cliente</label>
          <input
            type="text"
            name="cliente"
            placeholder="Nombre del cliente"
            value={form.cliente}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Tipo de préstamo</label>
          <select name="tipo" value={form.tipo} onChange={handleChange}>
            <option value="Diario">Diario</option>
            <option value="Semanal">Semanal</option>
          </select>
        </div>

        <div className="form-group">
          <label>Monto</label>
          <input
            type="number"
            name="monto"
            placeholder="Monto del préstamo"
            value={form.monto}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Fecha</label>
          <input
            type="date"
            name="fecha"
            value={form.fecha}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Plazo</label>
          <input
            type="number"
            name="plazo"
            placeholder="Días o semanas"
            value={form.plazo}
            onChange={handleChange}
            required
          />
        </div>

        {/* 🔥 Botones */}
        <div className="botones-form">
          <button type="button" className="btn-cancelar" onClick={handleCancel}>
            Cancelar
          </button>

          <button type="submit" className="btn-guardar">
            Guardar Préstamo
          </button>
        </div>

      </form>
    </div>
  );
}